import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { TranscribeEnum } from "@/shared/types.ts";

type StartTranscribePayload = {
  base64: string;
  extension: string;
  type: TranscribeEnum;
};

type Store = {
  base64: string | null;
  extension: string | null;
  transcribing: boolean;
  startTranscribe: (data: StartTranscribePayload) => void;
  type: TranscribeEnum | null;
  endTranscribe: () => void;
  fastRecord: boolean;
  startFastRecord: () => void;
  finishFastRecord: () => void;
};

export const useRecordProcessStore = create<Store>()(
  devtools(
    (set, getState) => ({
      base64: null,
      extension: null,
      transcribing: false,
      type: null,

      startTranscribe: (data: StartTranscribePayload) => {
        set({
          base64: data.base64,
          extension: data.extension,
          transcribing: true,
          type: data.type,
        });
      },
      endTranscribe: () => {
        set({ base64: null, extension: null, transcribing: false, type: null });
      },

      fastRecord: false,
      startFastRecord: () => {
        const currentState = getState();
        if (!currentState.transcribing) {
          set({ fastRecord: true });
        }
      },
      finishFastRecord: () => {
        set({ fastRecord: false });
      },
    }),
    { name: "RecordProcessStore" },
  ),
);
